import { render, staticRenderFns } from "./AppointmentResponsibleNotification.vue?vue&type=template&id=6bad3844&"
import script from "./AppointmentResponsibleNotification.vue?vue&type=script&lang=js&"
export * from "./AppointmentResponsibleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports